import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  noticeCarousel: {
    width: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  swiperContainer: {
    width: '100%',
    paddingBottom: '25px !important',
    '& .swiper-pagination-lock': {
      display: 'flex !important',
      visibility: 'visible !important'
    },
    '& .swiper-pagination': {
      bottom: '0px !important'
    },
    '& .swiper-pagination-bullet': {
      backgroundColor: theme.palette.grey[300],
      opacity: 1
    },
    '& .swiper-pagination-bullet-active': {
      backgroundColor: theme.palette.primary.dark
    },
    [theme.breakpoints.down('sm')]: {
      paddingBottom: '16px !important'
    }
  },
  navButton: {
    color: theme.palette.primary.contrastText,
    transition: 'color 0.3s ease',
    '&.swiper-button-disabled': {
      color: `${theme.palette.grey[300]} !important`,
      pointerEvents: 'auto'
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  }
}))
